/**
 * ReactMarkdown `components` override for bidirectional text safety.
 *
 * Adds `dir="auto"` to every rendered block element (p, li, blockquote).
 * This ensures paragraphs that mix Hebrew and English determine their base
 * direction per-paragraph rather than inheriting a single fixed direction
 * from the container element.
 *
 * Usage:
 *   import { bidiComponents } from "@/lib/bidi-components";
 *   <ReactMarkdown components={bidiComponents}>{text}</ReactMarkdown>
 *
 * Audit finding #31 — bidi reorder of punctuation in mixed-language narrator
 * output and message bubbles.
 */

import React from "react";

export const bidiComponents = {
  p: ({ children, ...props }: React.HTMLAttributes<HTMLParagraphElement>) => (
    <p dir="auto" {...props}>{children}</p>
  ),
  li: ({ children, ...props }: React.HTMLAttributes<HTMLLIElement>) => (
    <li dir="auto" {...props}>{children}</li>
  ),
  blockquote: ({ children, ...props }: React.HTMLAttributes<HTMLQuoteElement>) => (
    <blockquote dir="auto" {...props}>{children}</blockquote>
  ),
};
